import { sync } from 'vuex-pathify';

export default {

  computed: {
    ...sync([
      'layout/tabCount', //
      'layout/tabIndex',
    ]),
  },

  methods: {
    tabInput(/* tabIndex */) {
      // console.log(`tabInput ${tabIndex}`);
    },
    tabClicked(routeHash) {
      // console.log(`tabClicked ${routeHash}`);
      // console.log('tabClicked.route', this.$route.hash);
      if (this.$route.hash !== routeHash) {
        window.history.pushState({}, document.title, `${this.$route.path}${routeHash}`);
        // this.$router.replace(routeHash);
      }
    },
  },
};
